export default {
  partner:
    'Stel je Stripe-verwerkingskosten in of bevestig een marge van 0%. Tot die tijd kunnen je restaurants met Stripe niet live gaan.',
  partner_live_one:
    'Stel je Stripe-verwerkingskosten in of bevestig een marge van 0%. Tot die tijd kunnen je restaurants met Stripe niet live gaan en ontvangt je live restaurant geen online betalingen.',
  partner_live_other:
    'Stel je Stripe-verwerkingskosten in of bevestig een marge van 0%. Tot die tijd kunnen je restaurants met Stripe niet live gaan en ontvangen je {{count}} live restaurants geen online betalingen.',
  restaurant:
    'Online betalingen zijn gepauzeerd totdat je partner de verwerkingskosten instelt. Contante betalingen werken nog steeds.',
  cta: 'Verwerkingskosten instellen',
};
